export default __webpack_public_path__ + "static/media/smooth-metallic-object.1578612e.gif";